module.exports = __webpack_public_path__ + "img/check-icon.8947b333.svg";